<template>
  <el-dialog
    top="50px"
    width="500px"
    :title="item ? 'Sửa quyền tài khoản' : 'Thêm quyền tài khoản'"
    :visible="visible"
    :show-close="!callingAPI"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      size="medium"
      label-position="top"
    >
      <el-row
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
          :lg="24"
          :span="24"
        >
          <el-form-item
            prop="role_id"
            label="Quyền hạn"
          >
            <el-select
              v-model="form.role_id"
              :placeholder="`Chọn quyền`"
              class="w-100"
              filterable
              :disabled="callingAPI || !isChangeRole"
              :loading="loading"
            >
              <el-option
                v-for="(role, index) in roles"
                :key="index"
                :label="role.translations ? role.translations.vi.name : role.code"
                :value="role.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <div v-if="isShowInfo">
          <el-col
            :lg="12"
            :span="24"
          >
            <el-form-item
              prop="email"
              label="Địa chỉ email"
            >
              <el-input
                v-model="form.email"
                :disabled="!!item"
                placeholder="Nhập địa chỉ email"
              />
            </el-form-item>
          </el-col>
          <el-col
            :lg="12"
            :span="24"
          >
            <el-form-item
              prop="phone"
              label="Số điện thoại"
            >
              <el-input
                v-model="form.phone"
                :disabled="callingAPI || !isChangeInfo"
                placeholder="Nhập số điện thoại"
              />
            </el-form-item>
          </el-col>
          <el-col
            :lg="12"
            :span="24"
          >
            <el-form-item
              prop="first_name"
              label="Họ"
            >
              <el-input
                v-model="form.first_name"
                :disabled="callingAPI || !isChangeInfo"
                placeholder="Nhập họ"
              />
            </el-form-item>
          </el-col>
          <el-col
            :lg="12"
            :span="24"
          >
            <el-form-item
              prop="last_name"
              label="Tên"
            >
              <el-input
                v-model="form.last_name"
                :disabled="callingAPI || !isChangeInfo"
                placeholder="Nhập tên"
              />
            </el-form-item>
          </el-col>
          <el-col
            :lg="24"
            :span="24"
          >
            <el-form-item
              prop="avatar_url"
              label="Avatar"
            >
              <el-input
                v-model="form.avatar_url"
                :disabled="callingAPI || !isChangeInfo"
                placeholder="Nhập link avatar"
              />
            </el-form-item>
          </el-col>
          <el-col
            v-if="isCreate"
            :lg="24"
            :span="24"
          >
            <el-form-item
              prop="password"
              label="Mật khẩu"
            >
              <el-input
                v-model="form.password"
                :disabled="callingAPI || !isChangeInfo"
                type="password"
                placeholder="Nhập mật khẩu"
              />
            </el-form-item>
          </el-col>
        </div>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        :disabled="callingAPI"
        size="medium"
        @click="$emit('close')"
        >Đóng</el-button
      >
      <el-button
        v-if="isChangeRole && isChangeInfo"
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
        >Lưu</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { notification, convertPayloadData } from "@/utils/common";
import accountServices from "@/services/account";
import roleServices from "@/services/role";
import roleUserServices from "@/services/role-user";
import patterns from "@/config/patterns.js";

export default {
  name: "DataFormPopup",
  props: {
    item: Object,
    visible: Boolean,
    organizationId: String,
    permission: Object,
    accountPermission: Object,
    rolePermission: Object
  },
  data() {
    return {
      loading: false,
      form: {
        avatar_url: "",
        email: "",
        phone: "",
        first_name: "",
        last_name: "",
        password: "",
        role_id: "",
      },
      accountSearchText: "",
      callingAPI: false,
      roles: [],
    };
  },
  computed: {
    isCreate() {
      return !this.item || !this.item.id;
    },
    payloadData() {
      let payload = this.form;
      if (!this.isCreate) {
        delete this.form.password;
      }
      payload = {
        ...this.item,
        ...this.form
      };
      return convertPayloadData("user_roles", payload);
    },
    rules() {
      const result = {
        email: [
          {
            required: true,
            email: `Email là trường bắt buộc.`,
            trigger: ["blur", "change"],
          },
          {
            pattern: patterns.EMAIL,
            message: `Email không hợp lệ.`,
            trigger: ["blur", "change"],
          }
        ],
        phone: [
           {
            required: true,
            email: `Số điện thoại là trường bắt buộc.`,
            trigger: ["blur", "change"],
          },
          {
            pattern: patterns.PHONE,
            message: `Số điện thoại không hợp lệ.`,
            trigger: ["blur", "change"],
          }
        ],
        password: [
          {
            required: true,
            message: `Mật khẩu là trường bắt buộc.`,
            trigger: ["blur", "change"],
          },
        ],
        role_id: [
          {
            required: true,
            message: `Quyền hạn là trường bắt buộc.`,
            trigger: ["blur", "change"],
          },
        ]
      };
      return result;
    },
    isChangeRole() {
      if (this.item) {
        return this.permission.UPDATE && this.rolePermission.READ
      }
      return true;
    },
    isShowInfo() {
      if (this.item) {
        return this.accountPermission.READ
      }
      return true;
    },
    isChangeInfo() {
      if (this.item) {
        return this.accountPermission.UPDATE
      }
      return true;
    }
  },
  beforeMount() {
    this.fetchRoles();
    this.loadFormData();
  },
  methods: {
    fetchRoles() {
      if (this.rolePermission.READ) {
        this.loading = true;
        roleServices
          .list({
            offset: 0,
            limit: 999,
            locale: "en",
            filters: {
              organization_id: this.organizationId
            }
          })
          .then((response) => {
            this.roles = response.items;
            this.loading = false;
          })
          .catch(() => {
            this.roles = [];
            this.loading = false;
          });
      } else {
        this.roles = this.item ? [this.item.role] : []
      }
    },
    loadFormData() {
      if (this.item) {
        this.form = {
          role_id: this.item?.role_id,
          avatar_url: this.item.account.avatar_url,
          email: this.item.account.email,
          phone: this.item.account.phone,
          first_name: this.item.account.first_name,
          last_name: this.item.account.last_name,
        };
      } else {
        this.form = {
          avatar_url: "",
          email: "",
          phone: "",
          first_name: "",
          last_name: "",
          password: "",
          role_id: "",
        };
      }
    },
    remoteMethod(query) {
      this.accountSearchText = query;
    },
    handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.isCreate) {
            this.callingAPI = true;
            accountServices.create(
              this.payloadData
            )
              .then(() => {
                this.callingAPI = false;
                this.$emit("reload");
                notification(
                  this,
                  "success",
                  "create",
                  "tài khoản"
                );
                this.$emit("close");
              })
              .catch(() => {
                this.callingAPI = false;
                notification(
                  this,
                  "error",
                  "create",
                  "tài khoản"
                );
              });
          } else {
            this.callingAPI = true;
            try {
              if (this.isChangeRole && this.form.role_id !== this.item.role_id) {
                const payload = convertPayloadData("user_roles", {
                  id: this.item.id,
                  role_id: this.form.role_id,
                  account_id: this.item.account_id
                });
                await roleUserServices.update(payload)
              }
              if (this.isChangeInfo) {
                const payload = {
                  id: this.item.account_id,
                  avatar_url: this.form.avatar_url,
                  first_name: this.form.first_name,
                  last_name: this.form.last_name,
                  phone: this.form.phone,
                  organization_id: this.organizationId
                }
                await accountServices.update(payload)
              }
              this.callingAPI = false;
              this.$emit("reload");
              notification(
                this,
                "success",
                "create",
                "tài khoản"
              );
              this.$emit("close");
            } catch (error) {
              this.callingAPI = false;
              notification(
                this,
                "error",
                "update",
                "tài khoản"
              );
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
